import React from 'react';

interface ImageIconProps extends React.SVGProps<SVGSVGElement> {
    width?: number;
    height?: number;
    fill?: string;
}

const ImageIcon = ({ width = 48, height = 48, fill = 'black', ...props }: ImageIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M40.5 7.5H7.5C6.70435 7.5 5.94129 7.81607 5.37868 8.37868C4.81607 8.94129 4.5 9.70435 4.5 10.5V37.5C4.5 38.2956 4.81607 39.0587 5.37868 39.6213C5.94129 40.1839 6.70435 40.5 7.5 40.5H40.5C41.2956 40.5 42.0587 40.1839 42.6213 39.6213C43.1839 39.0587 43.5 38.2956 43.5 37.5V10.5C43.5 9.70435 43.1839 8.94129 42.6213 8.37868C42.0587 7.81607 41.2956 7.5 40.5 7.5ZM40.5 10.5V29.7656L35.6119 24.8794C35.3333 24.6007 35.0025 24.3797 34.6385 24.2289C34.2745 24.0781 33.8843 24.0005 33.4903 24.0005C33.0963 24.0005 32.7061 24.0781 32.3421 24.2289C31.9781 24.3797 31.6473 24.6007 31.3688 24.8794L27.6188 28.6294L19.3688 20.3794C18.8062 19.8172 18.0434 19.5014 17.2481 19.5014C16.4528 19.5014 15.6901 19.8172 15.1275 20.3794L7.5 28.0069V10.5H40.5ZM7.5 32.25L17.25 22.5L32.25 37.5H7.5V32.25ZM40.5 37.5H36.4931L29.7431 30.75L33.4931 27L40.5 34.0088V37.5ZM27 18.75C27 18.305 27.132 17.87 27.3792 17.5C27.6264 17.13 27.9778 16.8416 28.389 16.6713C28.8001 16.501 29.2525 16.4564 29.689 16.5432C30.1254 16.63 30.5263 16.8443 30.841 17.159C31.1557 17.4737 31.37 17.8746 31.4568 18.311C31.5436 18.7475 31.499 19.1999 31.3287 19.611C31.1584 20.0222 30.87 20.3736 30.5 20.6208C30.13 20.868 29.695 21 29.25 21C28.6533 21 28.081 20.7629 27.659 20.341C27.2371 19.919 27 19.3467 27 18.75Z"
            fill={fill}
        />
    </svg>
);

export default ImageIcon;
